import React from 'react'
import useOutsideClick from '@verzekeringapp-mono/shared/src/hooks/useOutsideClick'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IProps extends React.PropsWithChildren {
  onClose: () => void
  modalIcon?: React.ReactNode
  closeButtonHidden?: boolean
}

const Modal = ({ onClose, modalIcon, children, closeButtonHidden }: IProps) => {
  const ref = useOutsideClick(() => onClose())

  return (
    <div className='modal z-10'>
      <div
        className='relative max-h-3/4 flex flex-col justify-center items-center md:w-2/3 w-full'
        ref={ref}
      >
        {modalIcon}

        <div className='modal-content relative'>
          {!closeButtonHidden && (
            <button
              className='absolute top-4 right-4'
              onClick={onClose}
            >
              <FontAwesomeIcon icon={['fal', 'times']} />
            </button>
          )}

          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal
